export const removeSpaces = (text: string) => {
  const newText = text.replace(/ /g, '');
  return newText;
};
